import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn', 'userDetailsForNavigation']),
}

export const superAdminComputed = {
  ...mapState('superAdmin', ['serviceSuperAdmin']),
  ...mapGetters('superAdmin', ['getServiceSuperAdmin']),
}

export const providerComputed = {
  ...mapState('provider', [
    'questionList',
    'toPost',
    'addProduct',
    'addCheck',
    'addServiceInfo',
    'addProductDetails',
    'addCheckList',
    'checklistAdded',
    'QuestionListAdded',
    'ProductListAdded',
    'serviceId',
    'adminServiceDetails',
    'files',
    'secSelected',
    'infoById',
    'videofiles',
    'fileLogoImage',
    'percentageUpload',
    'ServiceRequestFormsStored',
  ]),
  // ...mapState( 'resident', ['servicesResident']),

  ...mapGetters('provider', [
    'questionList',
    'gettoPost',
    'getaddProduct',
    'getaddCheck',
    'getaddProductList',
    'getServiceDetails',
    'getAdminServiceDetails',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'getRefreshAuthToken',
  'getAuthToken',
  'validateToken',
  'getServiceToken',
])

export const providerMethods = mapActions('provider', [
  'PatchServicesRequestedByResidentForVendor_Blk',
  'PatchPayementServicesRequestedByResidentForVendor_Blk',
  'addVendorNoteForResident_BLK',
  'getAllServicesRequestedByResidentForVendor_Blk',
  'getActiveServicesCount_Blk',
  'searchingRequestFromSandoDatabase',
  'searchingRequestFromSandoDatabaseById',
  'getServiceRequestDetailsByID_BLK',
  'getAllServicesfunction_BLK',
  'getServiceDistributionCount_BLK',
  'getAllServiceForSequenceOrder_BLK',
  'loadSearchServices_BLK',
  'getAllServicesCategory_BLK',
  'addAllQuestions',
  'addProducts',
  'addCheckListItem',
  'addInfo',
  'setQuestionList',
  'incrementaddProduct',
  'incrementCheckList',
  'SetToPost',
  'postAllServices_BLK',
  'patchAllServices_BLK',
  'deleteImagesFromService_BLK',
  'deleteChoiceFromServiceQuestions_BLK',
  'deleteQuestionFromServiceQuestions_BLK',
  'deleteProductFromServiceProducts_BLK',
  'deleteBuildingLinkingFromTable_BLK',
  'addImagestoService_BLK',
  'addQuestionToServiceQuestions_BLK',
  'addProductToServiceProducts_BLK',
  'copyProducts',
  'setCheckListAdded',
  'setQuestionListAdded',
  'setProductListAdded',
  'setServiceID',
  'getServiceDetailsByID_BLK',
  'fileArray',
  'SET_SECTION_SELECTED',
  'SET_SERVICE_INFO_BY_ID',
  'signupProviderBLK',
  'editProviderBLK',
  'createCompanyProvider',
  'UserCreateProvider',
  'sendEmailNotificationToUser',
  'fileVideoArray',
  'fileLogo',
  'deleteParticularService_BLK',
  'clearFileArray',
  'clear_Upload_Percentage',
  'getListOfAllVendorInquiries_BLK',
  'loadSearchedEnquiryForVendor_BLK',
  'GetOrderListbyVendorID',
  'VendorConvertToOrderServiceRequest',
  'sendPaymentRequestToResident',
  'VendorPayoutAndOrderAnalysisReportAsync',
  'OrderAnalysisReportAsync',
  'SandOEarningReportAsync',
])

export const residentMethods = mapActions('resident', [
  'getAllServicesRequestedByResident_Blk',
  'searchingRequestforResident',
  'getServiceDetailsByIdForResident_BLK',
  'requestforEnquiry_BLK',
  'ServiceRequest_BLK',
  'ServiceEmailCommunication_BLK',
  'GetMessagesServiceRequestId_BLK',
  'sendResponseMessagesServiceRequestId_BLK',
  'getProductInformationById',
  'getServiceImagesArrayById',
  'getAllServicesForadminLandingPage_BLK',
  'getProviderByFacilityLink_BLK',
  'getResidentServicesBybuildingIdfunction',
  'sendUserServiceRequest',
  'inquiryRatingFeedback_BLK',
  'GetMilestoneDetailsbyServiceRequestId',
  'GetOrderListbyResidentID',
  'ServiceRequestRefundRequestByResident',
])
export const superAdminMethods = mapActions('superAdmin', [
  // Reporting APIs
  'BuildingAnalysisReportingAPI',
  'VendorAnalysisAsyncReportingAPI',
  'VendorRatingAnalysisAsyncReportingAPI',
  'buildingRatingAnalysisReportingAPI',
  'CategoryAnalysisAsyncReportingAPI',
  'ServiceAnalysisAsyncReportingAPI',
  'InquiryAnalysisAsyncReportingAPI',
  'InquiryAnalysisAsyncfunction',
  'adminMarginSettings',
  // End Here
  'getAllServicesAsyncfunction',
  'DeletionOfVendorServicesFunction',
  'getallVendorUserList',
  'AddNYCBuildingDistribution',
  'upadteAllServiceForSequenceOrder_BLK',
  'getListOfAllVendorForSandoAdmin_BLK',
  'getListOfAllFacility',
  'getListofVendorFromBuildingLink',
  'getListOfServicesForMargin_BuildingLink',
  'setMarginForService',
  'setMarginForVendor',
  'ServiceRequestRefundApproveRejectByAdmin',
  'GetAllOrderList',
  'GetListofPayout',
  'getMilestoneInformationFromBuildingLink',
  'getPayoutInformationFromBuildingLink',
  'ServiceRequestMilestoneRefunds',
  'searchingBuildingFromSandoDatabase',
  'getNoficationCount_BLK',
  'getListOfAllInquiries_BLK',
  'getServiceRequestId',
  'GetRequestContactDetailsByServiceRequestId',
  'getListOfAllBuildings_BLK',
  'getallservicesforsuperadmin',
  'getListOfAllFacilities_BLK',
  'getListOfAllserviceform_BLK',
  'getListOfAllSelected_BLK',
  'sendPaymentToVendor',
  'getListOfAllSelected_serviceForm_BLK',
  'loadSearchedServicesFromBuilding_BLK',
  'loadSearchedFacilities_BLK',
  'loadSearchedFacilitiesForReport_BLK',
  'loadSearchedVendor_BLK',
  'loadVendor_BLK',
  'loadSearchedEnquiry_BLK',
  'loadSearchedBuildings_BLK',
  'deleteVendor_BLK',
  'deleteEnquiries_BLK',
  'getAllProvidersForSuperAdmin_BLK',
  'getAllProvidersForSuperAdminForSearch_BLK',
  'getAllVendorCategory_BLK',
  'activateDeactivateVendor_BLK',
  'getVendorDetailsByUserId_BLK',
  'companyValidator_BLK',
  'emailValidator_BLK',
  'phoneValidator_BLK',
  'deleteImagesFromProviderMedia_BLK',
  'addImagestoProviderMedia_BLK',
  'deleteCategoryFromProviderCategoryMappings_BLK',
  'addcategorytoProviderCategoryMappings_BLK',
  'removeBuildingFromTable_BLK',
  'getAllservicesBybuildingId_BLK',
  'loadSearchedService_BLK',
  'addBuildingstoService_BLK',
  'getbuildingsinfobyIdBLK',
  'getbuildingsinfobyFacIdBLK',
  'disableSandoAsync',
])
